import { forkJoin } from 'rxjs';
import { TeamModel } from 'projects/core/src/lib/models/team.model';
import { EmployeeModel } from 'projects/core/src/lib/models/employee.model';
import { Component, OnInit, ViewChild } from '@angular/core';
import { UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { TranslocoService } from '@ngneat/transloco';
import { BaseForm } from 'projects/admin/src/app/classes/base-form';
import { ApiService } from 'projects/admin/src/app/services/api.service';
import { AuthStateService } from 'projects/admin/src/app/services/auth-state.service';
import { UiService } from 'projects/admin/src/app/services/ui.service';
import { MIN_PASSWORD_LENGTH } from 'projects/admin/src/app/shared/constants';
import { FormHelper } from 'projects/admin/src/app/shared/form-helper';
import { RoleModel } from 'projects/core/src/lib/models/role.model';
import { SelectItem } from 'primeng/api';
import { LANGUAGES, SALUTATIONS } from 'projects/core/src/lib/constants';
import { EmployeeSearchComponent } from 'projects/admin/src/app/shared/employee-search/employee-search.component';
import { CustomValidators } from 'projects/core/src/lib/validators/custom.validators';

@Component({
  selector: 'app-role-new',
  templateUrl: './role-new.component.html',
  styleUrls: ['./role-new.component.scss']
})
export class RoleNewComponent extends BaseForm implements OnInit {

  public form = this.fb.group({
    name: new UntypedFormControl('', [Validators.required]),
    title_de: new UntypedFormControl('', [Validators.required]),
    title_en: new UntypedFormControl('', [Validators.required]),
  });

  constructor(
    private fb: UntypedFormBuilder,
    private ui: UiService,
    private api: ApiService,
    private router: Router,
    private auth: AuthStateService,
    private transloco: TranslocoService
  ) {
    super();
  }

  ngOnInit(): void {
    this.auth.checkRightOrRedirect('admin.role.create');
    this.ui.setFormFocus();
  }

  onCancel(): void {
    this.router.navigate(['/roles']);
  }

  onSubmit(): void {
    this.ui.hideMessage();
    if (this.form.valid === true) {
      this.submitting = true;
      const payload: any = {
        id: null,
        name: this.form.value.name,
        title_de: this.form.value.title_de,
        title_en: this.form.value.title_en,
      };
      this.api.saveModel('roles', null, payload).subscribe({
        next: (result: any) => {
          this.router.navigate(['/roles', result.data.id]);
          this.ui.toastSuccess(this.transloco.translate('common.messages.saved', { value: this.form.value.name }), this.transloco.translate('common.saved'));
        },
        error: (error: any) => {
          this.ui.showMessage('error', this.transloco.translate(error.message), this.transloco.translate('common.error'));
          FormHelper.setBackendErrors(this.form, error.fielderrors);
        }
      }).add(() => {
        this.submitting = false;
      });
    } else {
      this.ui.showMessage('error', this.transloco.translate('common.error_on_form_please_correct'), this.transloco.translate('common.error'));
      FormHelper.markFormAsDirty(this.form);
    }
  }

}
